// extracted by mini-css-extract-plugin
export default {"ForgotPassword":"ForgotPassword_ForgotPassword__2fTM-","actions":"ForgotPassword_actions__r05hb"};